import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Box, Typography, Paper, Button, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useStyles } from './DevelopmentErrorBoundary_style'

const DevelopmentErrorFallback = ({ error, resetErrorBoundary, resetKeys }) => {
    const classes = useStyles()
    
    const handleReload = () => {
        window.location.reload()
    }
    
    const handleReset = () => {
        resetErrorBoundary()
    }
    
    const copyErrorToClipboard = () => {
        const errorText = `Error: ${error.message}\n\nStack Trace:\n${error.stack}`
        navigator.clipboard.writeText(errorText).then(() => {
            alert('Error details copied to clipboard!')
        })
    }

    return (
        <Box className={classes.errorContainer}>
            <Typography variant="h4" className={classes.errorTitle}>
                🚨 Development Error Boundary
            </Typography>
            
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
                An error occurred while rendering this component. This detailed error information is only shown in development mode.
            </Typography>
            
            <Typography variant="h6" style={{ marginBottom: '8px', color: '#c53030' }}>
                Error Message:
            </Typography>
            <Box className={classes.errorMessage}>
                {error.message}
            </Box>
            
            <Accordion className={classes.accordion} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">Stack Trace</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box className={classes.stackTrace}>
                        {error.stack}
                    </Box>
                </AccordionDetails>
            </Accordion>
            
            {error.componentStack && (
                <Accordion className={classes.accordion} defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">Component Stack</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box className={classes.componentStack}>
                            {error.componentStack}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            )}
            
            <Box>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleReset}
                    className={classes.actionButton}
                >
                    Try Again
                </Button>
                <Button 
                    variant="contained" 
                    color="secondary" 
                    onClick={handleReload}
                    className={classes.actionButton}
                >
                    Reload Page
                </Button>
                <Button 
                    variant="outlined" 
                    onClick={copyErrorToClipboard}
                    className={classes.actionButton}
                >
                    Copy Error Details
                </Button>
            </Box>
            
            <Typography variant="caption" style={{ marginTop: '16px', color: '#718096' }}>
                Reset Keys: {JSON.stringify(resetKeys)}
            </Typography>
        </Box>
    )
}

const DevelopmentErrorBoundary = ({ children, ...props }) => {
    const isDevelopment = process.env.NODE_ENV === 'development'
    
    if (!isDevelopment) {
        // In production, just render children without error boundary
        return children
    }
    
    return (
        <ErrorBoundary
            FallbackComponent={DevelopmentErrorFallback}
            resetKeys={[props.user?.id, window.location.pathname]}
            {...props}
        >
            {children}
        </ErrorBoundary>
    )
}

export default DevelopmentErrorBoundary